/**
 * Example usage
 *
 * transformColorFromTailwindColorsToRGB(tailwindColors.primary.DEFAULT) // tailwindColors.primary.DEFAULT = "var(--color-primary)"
 *
 * => output: "#eaf4f6"
 */
export function transformColorFromTailwindColorsToRGB(color: string): string {
  if (!color.includes('var')) throw new Error('Color is not a valid Tailwind color')

  const colorVarName = color.replace('var(', '').replace(')', '')
  const root = document.documentElement

  // Get the value of the CSS variable
  const rgbColor = getComputedStyle(root).getPropertyValue(colorVarName).trim()

  return rgbColor
}
